import { motion } from "framer-motion";

export const MaskedLine = ({ children, delay = 0, className = "", as = "span" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 40, ...rest }) => (
  <motion.div
    className={className}
    {...rest}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <p
    className={`inline-flex items-center gap-4 text-[11px] tracking-[0.5em] uppercase text-zinc-400 font-light ${className}`}
  >
    <span className="w-6 h-px bg-gradient-to-r from-transparent to-gold/70" />
    <span className="text-gold">&#9670;</span>
    {children}
  </p>
);
